import ArticlesCollection from './ArticlesCollection.vue'

export default ArticlesCollection
